(function() {
    'use strict';
    angular
        .module('corePRUGAGreatApp')
        .directive('format', format)
        .directive('formatprice', formatprice)
        .directive('formatAm', formatAm)
        .directive('numberMin', numberMin)
    	.directive('loadingPage', loadingPage)
    	.directive('compareNumber', compareNumber)
    	.directive('autoFocusErrorWhenSubmit', autoFocusErrorWhenSubmit)
    	.directive('fixedHeader', fixedHeader);
    formatprice.$inject = ['$filter', '$locale'];
    formatAm.$inject = ['$filter', '$locale'];
    format.$inject = ['$filter', '$locale'];
    compareNumber.$inject = ['$filter'];    
    fixedHeader.$inject = ['$timeout'];
    function format ($filter, $locale) {
        return {
            restrict: 'A',
            require: 'ngModel',
//            link: function postLink(scope, elem, attrs, modelCtrl) {    
//            	
//            	if (!modelCtrl) return;
//            	
//            	modelCtrl.$formatters.unshift(function (a) {
//                    return $filter(attrs.format)(modelCtrl.$modelValue);
//                });
//            	
//            	modelCtrl.$parsers.unshift(function (viewValue) {
//            		
//                    var plainNumber = viewValue.replace(/[^\d.]/g, '');
//                    elem.val($filter('number')(plainNumber));
//                    
//                    return plainNumber;
//                });
//            }
            link: function postLink(scope, elem, attrs, modelCtrl) {   
            	   modelCtrl.$parsers.push(function (inputValue) {
                      if (inputValue == undefined) return '';
//                      var tempInput = inputValue.replace(/^0+/, '');
                      var transformedInput = inputValue.replace(/[^0-9]/g, '');
                      if (transformedInput !== inputValue) {
                          modelCtrl.$setViewValue(transformedInput);
                          modelCtrl.$render();
                      }
//                      if(transformedInput != 0){
//                    	  elem.val($filter('number')(transformedInput));
//                      }
                      elem.val($filter('number')(transformedInput));
                      return transformedInput;
                  });
            }
        };
    }
    
    function formatprice ($filter, $locale) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function postLink(scope, elem, attrs, modelCtrl) {   
            	   modelCtrl.$parsers.push(function (inputValue) {
                      if (inputValue == undefined) return '';
                      var tempInput = inputValue.replace(/^0+/, '');
                      var transformedInput = tempInput.replace(/[^0-9]/g, '');
                      if (transformedInput !== inputValue) {
                          modelCtrl.$setViewValue(transformedInput);
                          modelCtrl.$render();
                      }
                      if(transformedInput != 0){
                    	  elem.val($filter('number')(transformedInput));
                      }
                     // elem.val($filter('number')(transformedInput));
                      return transformedInput;
                  });
            }
        };
    }
    
   function formatAm ($filter, $locale) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function postLink(scope, elem, attrs, modelCtrl) {    
            	if (!modelCtrl) return;
            		modelCtrl.$formatters.unshift(function (a) {
            			return $filter('number')(modelCtrl.$modelValue);
            		});
            	
            		modelCtrl.$parsers.unshift(function (viewValue) {
            			
            			var plainNumber = viewValue.replace(/[^-\d.]/g, '');
            			elem.val($filter('number')(plainNumber));
            			
            			return plainNumber;
            		});
            		
            	}	
            
        };
    }
    
    function numberMin() {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.numberMin = function (modelValue) {
                    if (!isNaN(modelValue) && modelValue !== "" && attributes.numberMin !== "")
                        return parseFloat(modelValue) >= attributes.numberMin;
                    else
                        return true;
                }
            }
        };
    }
    
    function loadingPage() {
    	return {
            restrict: 'E',
            replace:true,
            template: '<div class="loading"><div id="fountainTextG"><div id="fountainTextG_1" class="fountainTextG">P</div><div id="fountainTextG_2" class="fountainTextG">r</div><div id="fountainTextG_3" class="fountainTextG">u</div><div id="fountainTextG_4" class="fountainTextG">d</div><div id="fountainTextG_5" class="fountainTextG">e</div><div id="fountainTextG_6" class="fountainTextG">n</div><div id="fountainTextG_7" class="fountainTextG">t</div><div id="fountainTextG_8" class="fountainTextG">i</div><div id="fountainTextG_9" class="fountainTextG">a</div><div id="fountainTextG_10" class="fountainTextG">l</div><div id="fountainTextG_11" class="fountainTextG">.</div><div id="fountainTextG_12" class="fountainTextG">.</div><div id="fountainTextG_13" class="fountainTextG">.</div></div></div>',
            link: function (scope, element, attr) {
                  scope.$watch('loading', function (val) {
                      if (val)
                          $(element).show();
                      else
                          $(element).hide();
                  });
            }
          }
    }
    
    function compareNumber($filter) {
	   return {
	      require: 'ngModel', 
	      scope: {
	    	  'with': "=with"
	    	 
          },
	      link: function(scope, elem, attr, ngModel) {
	          
	         ngModel.$parsers.unshift(function(value) {
	        	var tempValue = value;
	        	if(tempValue == "")
	        		tempValue = 0;
	        	 var valid = !(parseFloat(scope.with) < 1 && parseFloat(tempValue) < 1);
	        	 
	        	 ngModel.$setValidity('blacklist', valid);
	        	 
	        	 var plainNumber = value.replace(/[^\d.]/g, '');
                 elem.val($filter('number')(plainNumber));
	        	 
	        	 return valid ? plainNumber : undefined;
	          });
	         
	         ngModel.$formatters.unshift(function(value) {
	        	 if(value == null || value == undefined)
	        		 value = 0;
	        	 if(scope.with == null || scope.with == undefined)
	        		 scope.with = 0;
	        	 
	        	  if(parseFloat(scope.with) < 1 && parseFloat(value) < 1){
	 	        	 ngModel.$setValidity('blacklist', false);
	 	         }
	        	 return value;
	          });
	      }
	   };
    }
    
    function autoFocusErrorWhenSubmit() {
    	return {
            scope: true,
            link: function (scope, element, attrs) {

                var form = scope[attrs.name];

                element.bind('submit', function(event) {
                    var field = null;
                    for (field in form) {
                        if (form[field].hasOwnProperty('$pristine') && form[field].$pristine) {
                            form[field].$dirty = true;
                        }
                    }

                    var invalid_elements = element.find('.ng-invalid');
                    if (invalid_elements.length > 0)
                    {
                       invalid_elements[0].focus();
                    }

                    event.stopPropagation();
                    event.preventDefault();
                });
            }
        };    	
    }
        
   function fixedHeader($timeout) {
        return {
            restrict: 'A',
            link: link
        };
 
        function link($scope, $elem, $attrs, $ctrl) {
            var elem = $elem[0];
 
            // wait for data to load and then transform the table
            $scope.$watch(tableDataLoaded, function(isTableDataLoaded) {
                if (isTableDataLoaded) {
                    transformTable();
                }
            });
 
            function tableDataLoaded() {
                // first cell in the tbody exists when data is loaded but doesn't have a width
                // until after the table is transformed
                var firstCell = elem.querySelector('tbody tr:first-child td:first-child');
                return firstCell && !firstCell.style.width;
            }
 
            function transformTable() {
                // reset display styles so column widths are correct when measured below
                angular.element(elem.querySelectorAll('thead, tbody, tfoot')).css('display', '');
 
                // wrap in $timeout to give table a chance to finish rendering
                $timeout(function () {
                    // set widths of columns
                    angular.forEach(elem.querySelectorAll('tr:first-child th'), function (thElem, i) {
 
                        var tdElems = elem.querySelector('tbody tr:first-child td:nth-child(' + (i + 1) + ')');
                        var tfElems = elem.querySelector('tfoot tr:first-child td:nth-child(' + (i + 1) + ')');
 
                        var columnWidth = tdElems ? tdElems.offsetWidth : thElem.offsetWidth;
                        if (tdElems) {
                            tdElems.style.width = columnWidth + 'px';
                        }
                        if (thElem) {
                            thElem.style.width = columnWidth + 'px';
                        }
                        if (tfElems) {
                            tfElems.style.width = columnWidth + 'px';
                        }
                    });
 
                    // set css styles on thead and tbody
                    angular.element(elem.querySelectorAll('thead, tfoot')).css('display', 'block');
 
                    angular.element(elem.querySelectorAll('tbody')).css({
                        'display': 'block',
                        'height': $attrs.tableHeight || 'inherit',
                        'overflow': 'auto'
                    });
 
                    // reduce width of last column by width of scrollbar
                    var tbody = elem.querySelector('tbody');
                    var scrollBarWidth = tbody.offsetWidth - tbody.clientWidth;
                    if (scrollBarWidth > 0) {
                        // for some reason trimming the width by 2px lines everything up better
                        scrollBarWidth -= 2;
                        var lastColumn = elem.querySelector('tbody tr:first-child td:last-child');
                        lastColumn.style.width = (lastColumn.offsetWidth - scrollBarWidth) + 'px';
                    }
                });
            }
        }
    }
})();
